import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Routes, RouterModule} from '@angular/router';

import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {UnrRoadtripListItemComponent} from './roadtrip-list-item/roadtrip-list-item.component';

import {RoadtripListPage} from './roadtrip-list.page';

const routes: Routes = [
  {
    path: '',
    component: RoadtripListPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    UnrRoadtripListItemComponent,
    RoadtripListPage
  ],
  exports: [
    UnrRoadtripListItemComponent
  ]
})
export class RoadtripListPageModule {
}
